import { Dropdown } from "react-bootstrap"
import { v4 as uuidv4 } from "uuid"

import { useAuth } from "../../context/auth-context"
import infoIcon from "../../assets/images/infoBlue.svg"

export default function DropdownOption(props) {
    const {
        option,
        optionValue,
        items = [{id: uuidv4(), title: "option 1", item: "option 1"}, {id: uuidv4(), title: "option 2", item: "option 2"}],
        handleCurrentInput,
        handleOptions,
        optionDisabled,
        handleShowInfo
    } = props

    const { user } = useAuth()

    const isDisabled = optionDisabled && (option.accessKey === "eap" ? !user?.inputsData?.population : !user?.inputsData?.eap)
    const selectedValue = items.find(item => item.item === optionValue)?.title

    return (
        <div className="optionContainer">
            <div className="icon-title-container">
                <span>{option.title}</span>
                <img className="d-lg-none mobile-info-icon" src={infoIcon} alt="Prodensa Teaser" onClick={() => handleShowInfo(option.accessKey)} />
            </div>

            <Dropdown onFocus={() => handleCurrentInput(option.accessKey)}>
                <Dropdown.Toggle disabled={isDisabled} className={`${optionValue ? "selected" : ""}`}>
                    {selectedValue ?? "Select value"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {items.map(item => {
                        return (
                            <Dropdown.Item key={item.id} onClick={() => handleOptions(item.item, option.accessKey)}>
                                {item.title}
                            </Dropdown.Item>
                        )
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}
